import React from 'react'
import OrderPage from '../components/Orders/OrderPage'

const OrderScreen = () => {
  return (
   <OrderPage/>
  )
}

export default OrderScreen